import { Route, Router, Routes } from 'react-router-dom';
import SignIn from '../pages/auth/signin';
import SignUp from '../pages/auth/signup';
import PrivateRoute from './Private_route';
import Home from '../pages/dashboard/home';
import Trending from '../pages/dashboard/trending';
import Report from '../pages/dashboard/report';
import Page_not_found from '../pages/page_not_found';
import Home_context_function from '../context/home_context';

export default function PageRouter() {

  return (
    <Routes>
      <Route path={'/signin'} element={<SignIn />} />
      <Route path={'/signup'} element={<SignUp />} />
      <Route
        path={'/home'}
        element={
          <PrivateRoute>
            <Home_context_function>
              <Home />
            </Home_context_function>
          </PrivateRoute>
        }
      />
      <Route
        path={'/home/report_id'}
        element={
          <PrivateRoute>
            <Home_context_function>
              <Report />
            </Home_context_function>
          </PrivateRoute>
        }
      />
      <Route
        path={'/trending'}
        element={
          <PrivateRoute>
            <Trending />
          </PrivateRoute>
        }
      />
      <Route path={'*'} element={<PrivateRoute>{<Page_not_found />}</PrivateRoute> } />
    </Routes>
  );
}
